import React from "react";
import { motion, AnimatePresence } from "motion/react";
import { MdsIconKind } from "@/design-system/components/icon";
import { StyledThoughtProcessChevronIcon } from "@/mds/components/sessions/session-item/thought-process/thought-process.style";

interface ThoughtProcessHeaderContentProps {
  headerText: string;
  isCollapsed: boolean;
  shouldShowChevron: boolean;
  shouldAnimate: boolean;
}

/**
 * Header component for thought process with animation support and collapse indicator.
 */
export const ThoughtProcessHeaderContent: React.FC<ThoughtProcessHeaderContentProps> = ({
  headerText,
  isCollapsed,
  shouldShowChevron,
  shouldAnimate,
}) => {
  const chevronIcon = isCollapsed ? MdsIconKind.AngleDown : MdsIconKind.AngleUp;

  const headerContent = (
    <>
      {headerText}
      {shouldShowChevron && <StyledThoughtProcessChevronIcon kind={chevronIcon} />}
    </>
  );

  if (!shouldAnimate) {
    return (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>{headerContent}</span>
    );
  }

  return (
    <AnimatePresence mode="wait">
      <motion.span
        key={headerText}
        initial={{
          opacity: 0,
          // NOTE - Temporarily disabling the vertical animation to avoid
          // some jankiness when scrolling. (The fade animation and transition trigger at the
          // same time when scrolling through session history.)
          // y: SESSION_HEADER_ANIMATION_OFFSETS.ENTER_FROM_TOP,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        exit={{
          opacity: 0,
          // y: SESSION_HEADER_ANIMATION_OFFSETS.EXIT_TO_BOTTOM,
        }}
        transition={
          {
            // duration: SESSION_ANIMATION_DURATIONS.HEADER_TEXT_FADE,
          }
        }
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {headerContent}
      </motion.span>
    </AnimatePresence>
  );
};
